/* "Sign in to keep this safe" — shown once, after someone has clearly put
   work into a device-only plan. Pure decision logic, unit-tested. */
export const NUDGE_AFTER_SAVES = 8;

export interface NudgeState { saves: number; nudged: boolean }
export interface NudgeCtx { cloudAvailable: boolean; signedIn: boolean; shareView: boolean }

/** Count a device-mode save; say whether this is the moment to nudge. */
export function recordSave(st: NudgeState, ctx: NudgeCtx): { st: NudgeState; nudge: boolean } {
  const saves = st.saves + 1;
  const nudge = !st.nudged && ctx.cloudAvailable && !ctx.signedIn && !ctx.shareView && saves >= NUDGE_AFTER_SAVES;
  return { st: { saves, nudged: st.nudged || nudge }, nudge };
}

const KEY = 'playout:nudge';
export function loadNudge(storage: { getItem(k: string): string | null } | null): NudgeState {
  try { const v = JSON.parse(storage?.getItem(KEY) || ''); return { saves: +v.saves || 0, nudged: !!v.nudged }; } catch { return { saves: 0, nudged: false }; }
}
export function saveNudge(storage: { setItem(k: string, v: string): void } | null, st: NudgeState): void {
  try { storage?.setItem(KEY, JSON.stringify(st)); } catch { /* private mode */ }
}
